import type { App } from "vue";
import "./index.css";
import AutoScreen from "./comp.vue";
export { AutoScreen };
export type { Props as AutoScreenProps } from "./interface";

const install = (vue: App) => {
  vue.component("AutoScreen", AutoScreen);
};
export default Object.assign(AutoScreen, {
  install,
});
